module.exports = __webpack_public_path__ + "img/img (24).f7d4b7d9.jpg";